export default __webpack_public_path__ + "static/media/left_pc.5753fb8a.png";